import Router from "./router/router";
import styles from "./App.module.scss";

const App = () => {
	return (
		<div className={styles.App}>
			<Router />
		</div>
	);
};

export default App;
